import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

const SuccessToast = ({ message, icon, duration = 2500, onClose }) => {
    useEffect(() => {
        const timer = setTimeout(() => {
            onClose(); // Auto-remove after the specified duration
        }, duration);

        return () => clearTimeout(timer); // Cleanup timer on unmount
    }, [duration, onClose]);

    return (
        <div className="toast-container toast-success">
            <div className="toast-content">
                <div className="toast-icon">
                    <img
                        src={icon ? icon : 'https://cdn-icons-png.flaticon.com/512/845/845646.png'}
                        alt="Success"
                    />
                </div>
                <div className="toast-message">{message}</div>
            </div>
            <div className="toast-effect"></div>
        </div>
    );
};

SuccessToast.propTypes = {
    message: PropTypes.string.isRequired,
    duration: PropTypes.number, // Duration in milliseconds
    onClose: PropTypes.func.isRequired,
};

export default SuccessToast;
